class CollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.loadMoreWrapper = document.querySelector('#main-collection-product-grid');
    this.ajaxSectionToLoad = 'collection-filters-ajax';
    this.wrapperID = '#products';
    this.wrapperIDSelector = '[data-products-wrapper]';

    this.fetching = false;
    this.initLoadMoreButtons();

    // trigger click on next button when it is in view
    this.observeButton('prev');
    this.observeButton('next');
  }

  /**
   * initLoadMoreButtons
   * @description Create the load more/prev buttons. Is also called again after fetch is done
  */
  initLoadMoreButtons() {
    this.currentPage = this.querySelector('[data-current-page]');
    this.currentPageValue = parseInt(this.currentPage.value);
    this.totalPages = this.querySelector('[data-total-pages]');
    this.totalPagesValue = parseInt(this.totalPages.value);

    // hide the buttons based on the page displayed
   (this.totalPagesValue === this.currentPageValue && this.querySelector('[data-collection-load-trigger="next"]') != null) ?
    this.querySelector('[data-collection-load-trigger="next"]').classList.add('hidden') : null;

   (this.currentPageValue === 1 && this.querySelector('[data-collection-load-trigger="prev"]') != null) ?
    this.querySelector('[data-collection-load-trigger="prev"]').classList.add('hidden') : null;

    this.loadTrigger = this.querySelectorAll('[data-collection-load-trigger]');
    this.loadTrigger.forEach(trigger => trigger.addEventListener('click', this.loadItems.bind(this)));
  }

  /**
   * loadItems
   * @description Gets the url to fetch and toggles the load items/loading text
   * @param {Object} event
  */
  loadItems(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    const linkElement = event.target.closest('a');
    const direction = linkElement.dataset.collectionLoadTrigger;
    linkElement.querySelector('[data-load-text]').classList.add('hidden');
    linkElement.querySelector('[data-loader]').classList.remove('hidden');

    const url = `${linkElement.href}&section_id=${this.ajaxSectionToLoad}`;
    this.renderProductsFromFetch(url,linkElement.href,direction);
  }

  /**
   * renderProductsFromFetch
   * @description Renders the products based on the fetch url data.
   * @param {String} url
   * @param {String} page
   * @param {String} direction
  */
  renderProductsFromFetch(url,page,direction) {
    // Don't fetch if already fetching
    if(this.fetching) return;
    this.fetching = true;
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      if (html.querySelector(`${this.wrapperID}`)) {

        // update the wrapper with the new products
        const newContent = html.querySelector(`${this.wrapperID} ${this.wrapperIDSelector}`).innerHTML;

        const newElement = document.createRange().createContextualFragment(newContent);

        // depending on the direction of the click, append or prepend the products and update the pagination
        if (direction == 'next') {

          this.loadMoreWrapper.querySelector(`${this.wrapperIDSelector}`).append(newElement);

          // update the pagination
          const paginationNextHtml = html.querySelector('#pagination-next').innerHTML;
          this.loadMoreWrapper.querySelector('#pagination-next').innerHTML = paginationNextHtml;
        }
        else {
          this.loadMoreWrapper.querySelector(`${this.wrapperIDSelector}`).prepend(newElement);

          // update the pagination
          const paginationPrevHtml = html.querySelector('#pagination-prev').innerHTML;
          this.loadMoreWrapper.querySelector('#pagination-prev').innerHTML = paginationPrevHtml;
        }

        // Update the LargeGrid based on their position
        const largeGrid = this.loadMoreWrapper.querySelectorAll('[data-large-grid]');
        largeGrid.forEach((grid, index) => {
          const data = JSON.parse(grid.dataset.largeGrid);
          const position = data.position;

          // {position: 8, start: 2, end: 4}
          // {position: 16, start: 5, end: 7}
          // {position: 24, start: 8, end: 10}
          // {position: 32, start: 8, end: 10}

          const start = position / 4 + index
          const end = start + 2;
          grid.style.gridRowStart = start;
          grid.style.gridRowEnd = end;
        })

        // rebind the event listener
        this.initLoadMoreButtons();

        // update the hidden input with the new value
        this.querySelector('[data-current-page]').value = page.split('page=')[1];

        // trigger click on button when it is in view
        this.observeButton(direction);

        // Allow fetching a new page
        this.fetching = false;
      }
    });
  }

  /**
   * Observe Element that triggers Button
  */
  observeButton(direction) {

    // Elements to watch that trigger the button
    const watchElements = (theType) => {
      return {
        next: document.querySelector(`[data-collection-load-trigger="next"]`) || false,
        prev: document.querySelector(`[data-collection-load-trigger="prev"]`) || false
      }[theType] || false;
    }

    // When observed element is reached, clicks button (if there)
    const obCallback = (entry) => {
      if (entry[0].isIntersecting) {
        const button = document.querySelector(`[data-collection-load-trigger="${direction}"]`) || false;
        if (button) button.click();
      }
    }

    if (watchElements(direction)) {
      const ob = new IntersectionObserver(obCallback);
      ob.observe(watchElements(direction));
    }

  }
}

if(!customElements.get('collection-load-more')) {
  customElements.define('collection-load-more', CollectionLoadMore);
}